<template>
  <div id="page-data-centre-persona-form">
    <vs-row>
      <vs-col>
        <vs-row>
          <vs-col>
            <vue-element-loading :active="busy"></vue-element-loading>
            <card-page :card-title="cardTitle">
              <div class="m-4" v-if="value.System">
                <h5>This is a system persona, it cannot be edited</h5>
              </div>
              <vue-form-generator
                  class="pt-4"
                  ref="personaForm"
                  :model="model"
                  :options="formOptions"
                  :schema="schema"
              />
            </card-page>
              <vue-form-generator
                  ref="form"
                  :model="model"
                  :options="formOptions"
                  :schema="schemaPrivileges"
              />
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
  </div>
</template>


<script>

import FormModelMixin from '@/components/mixins/FormModelMixin';
import CardPage from '../../../components/Views/CardPage';

const selectOptions = {
  showLabels: false,
  hideSelected: false,
  key: 'id',
  trackBy: 'id',
  label: 'name',
};

export default {
  name: 'DataCentrePersonaForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    cardTitle: {
      type: String,
      required: false,
    },
    overrideSystemPersona: {
      type: Boolean,
      required: false,
    },
  },
  mixins: [FormModelMixin],
  components: {
    CardPage
  },
  data() {
    return {
      model: {
        PersonaName: null,
        Role_FK: null,
        privileges: {}
      },
      checkboxStructure: [
        {
          mainLabel: 'Impersonate',
          subMenu: [
            {
              label: '',
              sections: [
                {
                  label: 'Impersonate Company',
                  route: 'impersonate_company',
                  fields: ['View'],
                },
              ],
            },
          ]
        },
        {
          mainLabel: 'Furness Underwriting Europe',
          subMenu: [
            {
              label: 'Portfolio Analysis',
              sections: [
                {
                  label: 'Production',
                  route: 'portfolio-analysis_production',
                  fields: ['View'],
                },
                {
                  label: 'Renewals',
                  route: 'portfolio-analysis_renewals',
                  fields: ['View'],
                },
                {
                  label: 'Statement of Accounts',
                  route: 'portfolio-analysis_statement-of-accounts',
                  fields: ['View'],
                },
                {
                  label: 'Claim Bordereau',
                  route: 'portfolio-analysis_claim-bordereau',
                  fields: ['View'],
                },
              ],
            },
          ]
        },
        {
          mainLabel: 'International Professional Risks Europe',
          subMenu: [
            {
              label: 'Facultative / Open Market Analysis',
              sections: [
                {
                  label: 'Production',
                  route: 'facultative-open-market-analysis_production',
                  fields: ['View'],
                },
                {
                  label: 'Renewals',
                  route: 'facultative-open-market-analysis_renewals',
                  fields: ['View'],
                },
                {
                  label: 'Statement of Accounts',
                  route: 'facultative-open-market-analysis_statement-of-accounts',
                  fields: ['View'],
                },
                {
                  label: 'Claim Bordereau',
                  route: 'facultative-open-market-analysis_claim-bordereau',
                  fields: ['View'],
                },
              ],
            },
            {
              label: 'Delegated Underwriting Authority (DUA)',
              sections: [
                {
                  label: 'Status Report',
                  route: 'dua_status-report',
                  fields: ['View'],
                },
                {
                  label: 'Risk Bordereaux – DDM template',
                  route: 'dua_risk-bordereaux{dash}ddm-template',
                  fields: ['View'],
                },
                {
                  label: 'Premium Bordereaux – DDM template',
                  route: 'dua_premium-bordereaux{dash}ddm-template',
                  fields: ['View'],
                },
                {
                  label: 'Claim Bordereau',
                  route: 'dua_claim-bordereau',
                  fields: ['View'],
                },
                {
                  label: 'Claims Triangulations',
                  route: 'dua_claims-triangulations',
                  fields: ['View'],
                },
              ],
            },
          ]
        }
      ],
      schema: {
        groups: [
          {
            styleClasses: 'w-full',
            fields: [
              {
                disabled: !!this.value.System && !this.overrideSystemPersona,
                type: 'input',
                inputType: 'text',
                styleClasses: 'w-1/3',
                label: 'Name',
                model: 'PersonaName',
                required: true,
                validator: ['string', 'required'],
              },
            ]
          },
          {
            styleClasses: 'w-full',
            fields: [
              {
                disabled: !!this.value.System && !this.overrideSystemPersona,
                type: 'vueMultiSelect',
                inputType: 'text',
                styleClasses: 'w-1/3',
                label: 'Role',
                model: 'Role_FK',
                required: true,
                validator: 'required',
                values: () => this.roles.map((role) => ({id: role.id, name: role.name})),
                selectOptions,
              },
            ]
          },
        ],
      },
      schemaPrivileges: {
        groups: [],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      formReferences: [
        'personaForm',
        'form',
      ],
      roles: [],
      options: [
        {
          endpoint: () => this.$api.dataCentrePersonas.listAvailableRoles(this.$route.params.id),
          optionsFieldName: 'roles',
          nameFieldName: 'RoleName',
          idFieldName: 'Role_FK',
          additionalFields: [
            'applications',
          ],
        },
      ]
    };
  },
  methods: {
    checkboxFields() {
      let fields = {};

      this.checkboxStructure.forEach((structure) => {
        fields = {
          styleClasses: 'vx-card w-full custom-checkboxes-wrapper',
          fields: []
        };

        fields.fields.push({
          type: 'label',
          label: structure.mainLabel,
          styleClasses: 'w-full main-label'
        })

        structure.subMenu.forEach((subMenu) => {
          fields.fields.push({
            type: 'label',
            label: subMenu.label,
            styleClasses: 'w-full sub-label'
          })

          subMenu.sections.forEach((section) => {
            fields.fields.push({
              type: 'label',
              label: section.label,
              styleClasses: 'w-full field-group-label'
            })

            section.fields.forEach((field) => {
              const modelName = `privileges.${section.route}.${field}`;
              const modelNameBase = `privileges.${section.route}.`;
              let disabled = false;

              if (this.model.privileges[section.route]) {
                if (field === 'List'
                    && (parseInt(this.model.privileges[section.route].View)
                        || parseInt(this.model.privileges[section.route].Edit)
                        || parseInt(this.model.privileges[section.route].Create)
                        || parseInt(this.model.privileges[section.route].Delete)
                        || parseInt(this.model.privileges[section.route].Restore))
                ) {
                  disabled = true;
                }

                if (field === 'View'
                    && (parseInt(this.model.privileges[section.route].Edit)
                        || parseInt(this.model.privileges[section.route].Restore))
                ) {
                  disabled = true;
                }
              }

              if (this.value.System && !this.overrideSystemPersona) {
                disabled = true;
              }

              fields.fields.push({
                disabled: disabled,
                type: 'checkbox',
                label: field,
                styleClasses: 'w-1/12 field',
                model: modelName,
                onChanged: (model, value) => {
                  const formFields = this.$refs.form.$children;
                  model.privileges[section.route][field] = value;

                  // if (value && (field === 'Edit' || field === 'Restore')) {
                  //   model.privileges[section.route].View = 1;
                  // }

                  // if (value && (field !== 'List')) {
                  //   model.privileges[section.route].List = 1;
                  // }

                  let listDisabled = false;
                  let viewDisabled = false;

                  // Only enable the list checkbox if all other fields are unchecked
                  section.fields.forEach((siblingField) => {
                    if (siblingField !== 'List'
                        && model.privileges[section.route][siblingField]
                    ) {
                      listDisabled = true;
                    }

                    if ((siblingField === 'Restore' || siblingField === 'Edit')
                        && model.privileges[section.route][siblingField]
                    ) {
                      viewDisabled = true;
                    }
                  });

                  formFields.forEach((formField) => {
                    if (formField.field.model === modelNameBase + 'List') {
                      formField.field.disabled = listDisabled;
                    }

                    if (formField.field.model === modelNameBase + 'View') {
                      formField.field.disabled = viewDisabled;
                    }
                  });
                }
              });
            });

            // This is used to force a line break between each section
            fields.fields.push({
              type: 'label',
              label: '',
              styleClasses: 'w-full'
            })
          });
        });

        this.schemaPrivileges.groups.push(fields);
      });
    },
  },
  async created() {
    await this.loadOpts();
    await this.checkboxFields();
  }
};
</script>

<style lang="scss">
#page-data-centre-persona-form {
  .vue-form-generator {
    .custom-checkboxes-wrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      padding-top: 1rem;
      margin-top: 1rem;

      .main-label {
        border-bottom: 1px solid #d5dae075;

        label {
          span {
            margin: 0;
            font-size: 20px;
            color: #2c2c2c;
          }
        }
      }

      .sub-label {
        border-bottom: 2px solid #626262;
        padding: 0 15px 5px;

        label {
          span {
            margin: 0;
            font-size: 15px;
            font-weight: bold;
          }
        }
      }

      .field-group-label {
        padding: 0 15px;
        width: 300px !important;

        label {
          span {
            margin: 0;
          }
        }
      }

      .field-checkbox {
        display: inline-flex;
        flex-direction: row;
        margin-right: 10px;
      }
    }
  }
}
</style>
